import { render, staticRenderFns } from "./PayoffDetail1Page.vue?vue&type=template&id=250af26e&scoped=true&"
import script from "./PayoffDetail1Page.vue?vue&type=script&lang=ts&"
export * from "./PayoffDetail1Page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250af26e",
  null
  
)

export default component.exports